export async function putFile(signedUrl, file) {
  const response = await fetch(signedUrl, {
    method: "PUT",
    body: file,
    headers: {
      "Content-Type": file.type,
    }
  });

  if (!response.ok) {
    throw new Error(await response.json());
  }
}

